/**
 * @description Hook utilizado para manipular o exame de Coincidência de Perfis Balísticos
 * @author Diego Sabino Amorim de Araújo
 * @file useExameCoincidenciaPerfisService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { setProcessando } from 'actions'
import { useFetch } from './useFetch'

export const useExameCoincidenciaPerfisService = () => {
  const fetch = useFetch()

  const listarExameCoincidenciaPerfisAsync = async (idExameCoincidencia, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/exameCoincidenciaPerfis/${idExameCoincidencia}`)
      return response.data.exameCoincidenciaPerfis
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }
  return {
    listarExameCoincidenciaPerfisAsync,
  }
}
